import {
  isCity,
  isAirport,
  PlaceType,
  PlaceSelectList,
  Airport,
  CityWithAirportsIata,
} from './types'

export const sliceIfMore = (arr: any[], long: number): any[] => {
  if (arr.length > long) return arr.slice(0, long)
  return arr.slice()
}

const orderAirportsWithinCities = (places: PlaceType[]) => {
  const cities = places.filter(isCity)
  let airports = places.filter(isAirport)
  const ordered = cities.reduce<(Airport | CityWithAirportsIata)[]>((acc, city) => {
    const cityAirports = airports.filter((airport) => airport.city_iata === city.iata)
    const airportsIatas = cityAirports.map((airport) => airport.iata)
    airports = airports.filter((airport) => airport.city_iata !== city.iata)
    const cityCopy = { ...city, airportsIata: airportsIatas ? airportsIatas : city.iata }
    return [...acc, cityCopy, ...cityAirports]
  }, [])
  return [...ordered, ...airports]
}

export const convertPlacesToSelectList = (places: PlaceType[]): PlaceSelectList[] => {
  const cities = places.filter(isCity)
  const orderedPlaces = orderAirportsWithinCities(places)

  return orderedPlaces.map((place) => ({
    fullName: `${place.iata} ${place.name}, ${place.country}`,
    name: place.name,
    rating: place.rating,
    iata: place.iata,
    iataToFetch: isAirport(place) ? place.iata : place.airportsIata,
    type: place.type,
    id: Object.values(place.location).join('').replace(/[.-]/g, '') + place.iata,
    hasCityWithin: isAirport(place) ? cities.some((city) => city.iata === place.city_iata) : false,
    lat: place.location.lat,
    lon: place.location.lon,
  }))
}
